import React, { useState } from 'react';
import { Box, TextField, Button, CircularProgress } from '@mui/material';
import { useNavigate, useParams } from 'react-router-dom';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import useMediaQuery from '@mui/material/useMediaQuery';
import { register } from '../../../utils/api';
import { createNotification } from '../../../utils/alerts';
import { getErrorMessage } from '../../../utils/errorUtils';
import AdminAuthLayout from '../../../components/admin/AdminAuthLayout';
import '../admin-auth.scss';

const textFieldSx = {
    '& .MuiOutlinedInput-root': {
        '&.Mui-focused fieldset': { borderColor: '#434851' },
    },
    '& .MuiInputLabel-root.Mui-focused': { color: '#434851' },
};

export default function AdminRegisterPage() {
    const navigate = useNavigate();
    const { invite_token } = useParams();
    const isMobile = useMediaQuery('(max-width:600px)');
    const [form, setForm] = useState({ full_name: '', password: '', confirm_password: '' });
    const [loading, setLoading] = useState(false);

    const handleChange = (e) => setForm((prev) => ({ ...prev, [e.target.name]: e.target.value }));

    const handleSubmit = async (e) => {
        e.preventDefault();
        if (form.password !== form.confirm_password) {
            createNotification('error', 'As senhas não coincidem.', isMobile);
            return;
        }
        setLoading(true);
        try {
            await register(invite_token, form);
            createNotification('success', 'Cadastro concluído com sucesso!', isMobile);
            navigate('/admin/login');
        } catch (err) {
            createNotification('error', getErrorMessage(err, 'Erro ao concluir o cadastro.'), isMobile);
        } finally {
            setLoading(false);
        }
    };

    return (
        <AdminAuthLayout title="Concluir Cadastro">
            <Box component="form" onSubmit={handleSubmit} className="admin-auth-form">
                <TextField
                    fullWidth
                    label="Nome completo"
                    name="full_name"
                    type="text"
                    value={form.full_name}
                    onChange={handleChange}
                    required
                    size="small"
                    sx={textFieldSx}
                />
                <TextField
                    fullWidth
                    label="Senha"
                    name="password"
                    type="password"
                    value={form.password}
                    onChange={handleChange}
                    required
                    size="small"
                    sx={textFieldSx}
                />
                <TextField
                    fullWidth
                    label="Confirmar senha"
                    name="confirm_password"
                    type="password"
                    value={form.confirm_password}
                    onChange={handleChange}
                    required
                    size="small"
                    sx={textFieldSx}
                />
                <Button
                    type="submit"
                    variant="contained"
                    fullWidth
                    disabled={loading}
                    className="admin-auth-submit-btn"
                >
                    {loading ? <CircularProgress size={22} color="inherit" /> : 'Concluir cadastro'}
                </Button>
                <Button
                    variant="text"
                    fullWidth
                    onClick={() => navigate('/admin/login')}
                    className="admin-auth-link-btn"
                >
                    Ir para o login
                </Button>
            </Box>
            <ToastContainer />
        </AdminAuthLayout>
    );
}
